import { ContainerV2, H1, P } from "../../Atoms";
import { CardTypeHome } from "./Component/CardTypeHome";
import { useHomeV2 } from "./useHomeV2";

export const HomeV2 = () => {
  const {
    empresa,
    mostrarItinerante,
    handleLoja,
    handleDomicilio,
    handleItinerante,
    stepIndicator,
  } = useHomeV2();

  return (
    <ContainerV2 backButton={false}>
      {stepIndicator}

      <H1 className="mb-4 mt-8">Como você prefere ser atendido?</H1>
      <P className="mb-6">
        Escolha entre levar o veículo a uma de nossas unidades ou agendar o
        atendimento delivery.
      </P>

      <div className="flex flex-wrap gap-4 md:gap-12 justify-center">
        <CardTypeHome
          icon={
            <img src="/assets/svgs/icon-place.svg" alt="icone localizacão" />
          }
          title="Loja / Ciretran"
          buttonText="Selecionar unidade"
          buttonAction={handleLoja}
        >
          <P variant="small">
            Realize sua{" "}
            <strong>vistoria veicular na unidade mais próxima.</strong> Nas
            nossas lojas e nas Ciretrans, você encontra:
          </P>
          <P variant="small">
            <img
              src="/assets/svgs/icon-ok.svg"
              alt="icone check"
              className="inline-block mr-2"
            />
            <span>
              {" "}
              Equipe técnica e completa para realização do seu{" "}
              <strong>serviço de forma rápida;</strong>
            </span>
          </P>
          <P variant="small">
            <img
              src="/assets/svgs/icon-ok.svg"
              alt="icone check"
              className="inline-block mr-2"
            />
            Ampla sala de espera.
          </P>
          <P variant="small">
            Realize seu agendamento e{" "}
            <strong>compareça no local, data e hora marcada.</strong> Consulte
            na Home do nosso site os endereços.
          </P>
        </CardTypeHome>

        <CardTypeHome
          icon={
            <img src="/assets/svgs/icon-moped.svg" alt="icone localizacão" />
          }
          title="Delivery"
          buttonText="Informar endereço"
          buttonAction={handleDomicilio}
        >
          <P variant="small">
            Você escolhe o <strong>local que preferir</strong> e a gente realiza
            a vistoria:
          </P>
          <P variant="small">
            <img
              src="/assets/svgs/icon-ok.svg"
              alt="icone check"
              className="inline-block mr-2"
            />
            <span>
              <strong>No conforto do seu lar:</strong> Receba o nosso
              profissional em sua casa, sem precisar se preocupar com trânsito
              ou estacionamento.
            </span>
          </P>
          <P variant="small">
            <img
              src="/assets/svgs/icon-ok.svg"
              alt="icone check"
              className="inline-block mr-2"
            />
            <strong>Na praticidade da concessionária:</strong> Combine a
            vistoria no pátio da concessionária antes de retirar o veículo.
          </P>
        </CardTypeHome>

        {mostrarItinerante && (
          <CardTypeHome
            icon={
              <img
                src="/assets/svgs/icon-explorer.svg"
                alt="icone localizacão"
              />
            }
            title="Itinerante"
            buttonText="Selecionar itinerante"
            buttonAction={handleItinerante}
          >
            <P variant="small">
              Sua cidade ainda não tem{" "}
              <strong>{empresa}? Sem problemas!</strong>
            </P>
            <P variant="small">
              <strong>Confira as próximas viagens programadas</strong> Receba o
              nosso Confira as para sua cidade e garanta já a sua vistoria!
            </P>
            <P variant="small">
              As <strong>vagas são limitadas</strong>, então não perca tempo!
            </P>
          </CardTypeHome>
        )}
      </div>
    </ContainerV2>
  );
};
